import { getWindow } from './getWindow';
import { getAppPathPrefix } from './legacyAppPath';

/**
 * todo: INSPIRE-8862: убрать префикс `/rythm` после переключения балансера.
 *
 * Ссылка на форму регистрации: текущий origin + legacy prefix (если URL ещё
 * на `/rythm`) + `/businesses/registration`.
 */
export const getRegistrationLink = (): string => {
    const location = getWindow()?.location;

    return `${location?.origin}${getAppPathPrefix(
        location?.pathname ?? '/',
    )}/businesses/registration`;
};
